module.exports = __webpack_public_path__ + "img/dump_stopped.877fcb3d.svg";